var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"padding":"0"}},[_c('BackButton'),_c('ContentTemplate',{attrs:{"contentUrlPath":"adults_learnmore"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }